import { createAsyncThunk } from "@reduxjs/toolkit";
import userPlanPurchaseApi from "api/userPlanPurchaseApi";
import { formatQueryParams } from "helpers/format";

export const getUserPlanPurchases = createAsyncThunk("UserPlanPurchases", async (params: any = {}) => {
  try {
    const response = await userPlanPurchaseApi.getUserPlanPurchases(formatQueryParams(params));
    return response;
  } catch (error) {
    return error;
  }
});

export const updateUserPlanPurchase = async (id: string | number, data: any = {}) => {
  try {
    const response = await userPlanPurchaseApi.putUserPlanPurchase(id, data);
    return response;
  } catch (error) {
    return error;
  }
};
